<template>
  <div class="wrapper bg-exitos">
    <notifications></notifications>
    <SidebarLayout />

    <div class="main-content d-flex flex-column">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div
        @click="$sidebar.displaySidebar(false)"
        class="bg-white flex-grow-1 rounded"
      >
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view class="main-content-view"></router-view>
        </fade-transition>
      </div>
      <content-footer
        class="mt-auto"
        v-if="!$route.meta.hideFooter"
      ></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./Default/DashboardNavbar.vue";
import ContentFooter from "./Default/ContentFooter.vue";
import SidebarLayout from "./Default/SidebarLayout.vue";

//import DashboardContent from './Default/Content.vue';
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarLayout,
    FadeTransition,
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style lang="scss">
.rounded {
  border-top-left-radius: 0.5em !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
